const TRANSLATION = {
  common: {
    loading: '載入中',
  },
  i18n: {
    English: '英語',
    Spanish: '西班牙語',
    Russian: '俄語',
    'Portuguese (Brazil)': '葡萄牙語（巴西）',
    Indonesian: '印度尼西亞語',
    Czech: '捷克語',
    German: '德語',
    French: '法語',
    Italian: '意大利語',
    Dutch: '荷蘭語',
    Polish: '波蘭語',
    Vietnamese: '越南語',
    Turkish: '土耳其語',
    Ukrainian: '烏克蘭語',
    Chinese: '簡體中文',
    'Traditional Chinese': '繁體中文',
    Japanese: '日語',
    Korean: '韓語',
    Arabic: '阿拉伯語',
    Persian: '波斯語',
    Thai: '泰語',
    Hindi: '印地語',
    Malay: '馬來語',
    province: {
      Hebei: '河北省',
      Shanxi: '山西省',
      Liaoning: '遼寧省',
      Jilin: '吉林省',
      Heilongjiang: '黑龍江省',
      Jiangsu: '江蘇省',
      Zhejiang: '浙江省',
      Anhui: '安徽省',
      Fujian: '福建省',
      Jiangxi: '江西省',
      Shandong: '山東省',
      Henan: '河南省',
      Hubei: '湖北省',
      Hunan: '湖南省',
      Guangdong: '廣東省',
      Hainan: '海南省',
      Sichuan: '四川省',
      Guizhou: '貴州省',
      Yunan: '雲南省',
      Shaanxi: '陝西省',
      Gansu: '甘肅省',
      Qinghai: '青海省',
      Taiwan: '臺灣省',
      Guangxi: '廣西壯族自治區',
      Neimenggu: '內蒙古自治區',
      Tibet: '西藏自治區',
      Ningxia: '寧夏回族自治區',
      Xinjiang: '新疆維吾爾自治區',
      HongKong: '香港特別行政區',
      Macau: '澳門特別行政區',
      Beijing: '北京市',
      Tianjin: '天津市',
      Shanghai: '上海市',
      Chongqing: '重慶市',
    },
  },
  pageHeader: {
    product: '產品',
    tvcTest: 'TVC 體驗測試',
    tvcEval: 'TVC 創意評估',
    contactUs: '聯繫我們',
    Pricing: '定價',
    Dashboard: '立即開始',
    signIn: '登入',
    signUp: '註冊',
    resourceCenter: '資源中心',
    all: '全部',
    news: '新聞',
    insight: '洞察',
    case: '案例',
  },
  productSwitch: {
    common: {
      comingSoon: '即將上線',
    },
    modal: {
      heroTitle: '請選擇您想執行的測試項目',
      heroSubtitle: 'AdEff 隨時為您提供多面向的創意洞察。',
      remainingTimes: '剩餘次數：{{count}}',
      supportedAssets: '支援素材',
      coreMetrics: '核心指標',
      cognitiveNeuroscienceIndicators: '認知神經指標',
      consumerAttitudeIndicators: '消費者態度指標',
      outputResult: '輸出結果',
      dataReport: '數據報告',
      analysisReport: '分析報告',
      accessBackend: '立即開始',
      tabs: {
        tvc: '橫式創意測試',
        portrait: '直式創意測試',
      },
      cards: {
        tvcQuick: {
          title: '橫式-快測',
          descriptionHighlight: '多中選優，快速決策',
        },
        tvcBase: {
          title: '橫式-創意診斷',
          descriptionHighlight: '精細打磨創意細節，提供可落地的修改建議',
          value1: '10-60 秒 TVC/OTV 創意',
          value2: '認知神經指標',
        },
        tvcSurvey: {
          title: '橫式-深度洞察',
          descriptionHighlight: '多維評估創意表現，提供創意優化策略指導',
          value1: '10-60 秒 TVC/OTV 創意',
          value2: '認知神經指標',
        },
        portraitQuick: {
          title: '直式-快測',
          descriptionHighlight: '多中選優，快速決策',
        },
        portraitBase: {
          title: '直式-創意診斷',
          descriptionHighlight: '精細打磨創意細節，提供可落地的修改建議',
          value1: '5-90 秒直式創意',
          value2: '認知神經指標',
        },
        portraitSurvey: {
          title: '直式-深度洞察',
          descriptionHighlight: '多維評估創意表現，提供創意優化策略指導',
          value1: '5-90 秒直式創意',
          value2: '認知神經指標',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: '橫式創意測試',
          assetText: '適用於10—60秒TVC/OTV創意',
        },
        portrait: {
          bannerTitle: '直式創意測試',
          assetText: '適用於5—90秒直式創意',
        },
      },
      items: {
        tvcQuick: {
          description: '又快又準，選出最優',
        },
        tvcBase: {
          title: '創意診斷',
          description: '逐秒優化，精雕創意',
        },
        tvcSurvey: {
          title: '深度洞察',
          description: '全面剖析，定位癥結',
        },
        portraitBase: {
          title: '創意診斷',
          description: '逐秒優化，精雕創意',
        },
        portraitQuick: {
          description: '又快又準，選出最優',
        },
        portraitSurvey: {
          title: '深度洞察',
          description: '全面剖析，定位癥結',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: '我們使用cookies',
    desc: '我們使用必要的cookies確保我們的網站正常運行。在您的同意下，我們還使用分析cookies來改善您的用戶體驗。查看我們的Cookie政策在我們的隱私政策中。',
    btn1: '拒絕所有',
    btn2: '接受所有',
    cookiePolicy: 'Cookie政策',
  },
  landing: {
    banner: {
      text1: 'AI驅動',
      text2: '廣告',
      text3: '測試',
      text4: '創意測試和優化平台',
      feature1: '內容解碼',
      feature2: '反饋預測',
      feature3: '數據整合',
      feature4: '結論推理',
      btn1: '獲取演示',
      btn2: '創建項目',
    },
    info: {
      title: '基於超圖多模態大語言模型（HMLLM）*，快速實現創意的效果預測，提升廣告投資回報',
      subTitle: '*此模型基於大量神經營銷學測試與多智能體構建',
      detail1: '快速廣告測試',
      detail1Desc:
        'AdEff可以在15分鐘內獲得目標受眾注意力曲線、情感波動以及對創意內容的參與度，並提供詳細評估報告及優化指導。',
      detail2: '快速篩選最優創意',
      detail2Desc: 'AdEff支持對多個創意的同時測量，幫助品牌做出快速決策。並提供詳細對比分析。',
      detail3: '一鍵剪輯，生成多樣有效版本',
      detail3Desc: 'AdEff支持一鍵剪輯，可快速生成多樣有效版本，適用於多種傳播場景。',
    },
    advantages: {
      title: 'AdEff優勢',
      item1Title: '快速響應',
      item1Desc: '最快 <tmp>15分鐘</tmp> 即可獲得報告。',
      item2Title: '獨特的AI模型',
      item2Desc: '獨有基於受眾反饋的 <tmp>AI模型</tmp>。',
      item3Title: '可視化圖表',
      item3Desc: '<tmp>可視化圖表</tmp>+AI智能解讀，測試報告一鍵生成',
      item4Title: '龐大的數據範圍',
      item4Desc: '<tmp>50,000+</tmp> 創意數據庫',
      item5Title: '專家團隊',
      item5Desc: '<tmp>專家團隊</tmp>提供支持和指導',
    },
    service: {
      title: 'AdEff服務方式',
      desc: '選擇您需要的服務方式',
      topTitle: '線上自助服務',
      topRow1: '自主建項完成測試',
      topRow2: '可視化圖表 + AI解讀報告',
      topRow3: '客觀神經科學指標分析（眼動 + 腦電）',
      topRow4: '獨有AI模型測試',
      bottomTitle: '專家團隊服務',
      bottomRow1: '專家建項完成測試',
      bottomRow2: '客觀神經科學指標分析（眼動 + 腦電）、可選增加主觀指標',
      bottomRow3: '可視化圖表 + 專家解讀報告',
      bottomRow4: '獨有AI模型測試、可選真人樣本測試',
    },
    footer: {
      title:
        'AdEff依託於超圖多模態大語言模型（HMLLM），通過超圖構建視覺元素EEG信號和眼動追蹤數據之間的複雜關係，實現廣告創意的快速測試',
      email: '電子郵箱',
      belongDesc: '<tmp>明略科技</tmp>旗下產品',
    },
    startBtn: '立即開始',
  },
  contact: { title: '聯繫我們', copy: '複製', message: { success: '複製成功' } },
  pricing: {
    title: 'AI驅動的創意測試及優化專家',
    starter: {
      title: '基礎版',
      desc_1: '適用於單次測試，即買即用',
      desc_2: '適用於少量測試，即買即用',
      timesDesc: '<strong>{{count}}</strong>次測試',
      timesDesc1: '<strong>{{count}}</strong>次測試',
      discount: '限時5折',
      originPrice: '原價',
      desc2: '基於受眾反饋的超圖多模態大語言模型',
      desc3: '快速響應，最快15分鐘即可生成報告',
      desc4: '豐富的可視化圖表',
      desc5: '專業的AI智能解讀',
      desc6: '全球數據庫與基準',
      cardDesc1: '限時折扣，僅需{{pricePerTest}}',
      cardDesc2: '次數永久有效',
    },
    premium: {
      time: '次',
    },
    unlimited: {
      title: '無限版',
      cardDesc1: '低至{{pricePerTest}}',
      cardDesc2: '次數有效期為一年',
      cardDesc3: '定制自有基準值',
      planDesc500: '全年暢享500次測試',
      planDesc1000: '全年暢享1,000次測試',
    },
    benefits: {
      title: '為什麼選擇AdEff?',
      subtitle: '購買AdEff，您可以獲得以下權益：',
      expertSupport: '專家團隊提供支持和指導',
      moreNeedsTitle: '有其他購買需求？',
      customPlanPrefix: '我們支持多種靈活與定制化方案——歡迎聯繫我們',
      customPlanSuffix: '獲取專屬方案',
    },
    subscribeBtn: '立即訂閱',
    contactUs: '聯繫我們',
  },
  login: {
    loginText: '登入',
    signUpText: '免費<tmp>註冊</tmp>',
    text1: '成功加入團隊',
    text1Desc:
      'AdEff基於超圖多模態大語言模型（HMLLM），構建視覺元素EEG信號和眼動追蹤數據之間的複雜關係，實現廣告創意的快速測試',
    text2: '用戶已加入企業',
    text3: '團隊邀請已過期',
    text4: '團隊邀請鏈接不再有效。',
    optionText1: '已經有帳戶？',
    optionText2: '沒有帳戶？',
    alertText1: '註冊即同意',
    alertText2: '註冊即同意',
    termsOfService: '服務條款',
    privacy: '隱私政策',
    privacyTips: '請在註冊前勾選同意協議。',
    and: '和',
    or: '或',
    next: '下一步',
    googleLogin: 'Google郵箱登入',
    googleSignUp: 'Google郵箱註冊',
    loginWithEmail: '電子郵箱登入',
    signUpWithEmail: '郵箱帳號註冊',
    password: '密碼',
    emailAddress: '帳號',
    enterEmail: '輸入您的電子郵箱',
    enterPassword: '輸入您的密碼',
    confirmPassword: '確認密碼',
    forgotPassword: '忘記密碼？',
    inconsistentPassword: '密碼不一致',
    verificationCode: '驗證碼',
    emptyVerificationCode: '驗證代碼不能為空',
    enterVerificationCode: '輸入驗證代碼',
    sendedVerificationCode: '驗證代碼已發送到您的電子郵件',
    emailOrPasswordNotCorrect: '電子郵箱或密碼不正確。',
    message: {
      text1: '輸入內容無效',
      text2: '電子郵箱已註冊',
      text3: '驗證代碼驗證錯誤！',
      text4: '該帳戶沒有綁定到企業，請重新結合！',
      text5: '請輸入正確的電子郵箱格式',
      text6: '密碼長度不能小於12位',
      text7: '密碼必須包含大寫字母、小寫字母和數字',
      requestLimit: '請求超限，請稍後再試',
    },
  },
  resetPwdPage: {
    submit: '提交',
    emailNotFound: '請檢查電子郵箱',
    emailHasSent: '電子郵件已發送至 {{email}}',
    checkYourInbox: '檢查您的電子郵件',
    resetYourPassword: '重置密碼',
    resetLinkHasSent: '重置密碼鏈接已發送至您關聯的電子郵箱，請檢查您的電子郵件',
    enterYourEmailAddress: '輸入您的電子郵箱地址',
    didNotGetEmail: '未收到電子郵件？',
    tryAgain: '重試',
    goBackToSign: '返回登入',
    email: '電子郵箱',
    enterYourEmail: '輸入您的電子郵箱',
    resetPassword: '重置密碼',
    resetPwdSuccess: '密碼重置成功',
    message: {
      resetLinkCodeError: '連結中的代碼無效',
      requestLimit: '請求超限，請稍後再試',
    },
  },
  memberRequestPage: {
    title: '驗證成員請求',
    subTitle: '請求來自：',
    deny: '拒絕',
    approve: '同意',
    teamFull: '團隊滿員',
    yourTeamIsFull: '您的團隊已滿。您可以聯繫我們獲取更多會員或刪除其他成員。',
    manageMembers: '管理 AdEff 中的成員',
    requestApproved: '已同意請求',
    approvedDesc: '您已同意 <tmp>{{name}}</tmp> 加入您的團隊，已自動發送通知郵件。',
    requestDeclined: '已拒絕請求',
    declinedDesc: '您已拒絕 <tmp>{{name}}</tmp> 加入您的團隊，已自動發送通知郵件。',
  },
  infoBindPage: {
    title: 'AI驅動廣告測試',
    desc: '基於超圖多模態大語言模型（HMLLM）*，快速實現創意的效果預測，提升廣告投資回報',
    joinAdEff: '加入 AdEff 並開啟新旅程',
    advantages: {
      title1: '更強大',
      desc1: '基於龐大資料庫的獨特AI模型',
      title2: '更經濟',
      desc2: '只需傳統方式的10%價格',
      title3: '更快速',
      desc3: '最快15分鐘即可獲取報告',
      title4: '更專業',
      desc4: '享受24/7的服務支援，和專家團隊服務',
    },
    username: '用戶名',
    company: '公司',
    placeOfResidence: '國家/區域',
    invitationCode: '推薦碼',
    createAccountForFree: '免費創建帳戶',
    refreshStatus: '刷新狀態',
    reapply: '重新申請',
    bySigningUp: '註冊即同意',
    termsOfService: '服務條款',
    and: '和',
    privacyPolicy: '隱私政策',
    message: {
      success: '已發送創建帳戶的請求，請耐心等待！',
      success2: '帳戶創建成功',
      error: '帳戶創建失敗，請稍後再試。',
      accountCreatedDirectly: '已為您直接創建帳戶！',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou: '請求已通過，頁面將自動跳轉。',
      theRequestHasBeenSendAndPleaseBePatient: '已發送請求，請耐心等待！',
      wrongRouting: '路由錯誤，頁面將自動跳轉。',
      yourRequestHasBeenDeclined:
        '您的請求已被拒絕。您可以重新申請加入團隊或創建一個沒有邀請碼的新帳戶。',
      waitingForAdministratorReview: '等待管理員審核',
      thisFieldIsRequired: '此字段為必填項',
      pleaseEnterTheResidence: '請輸入國家',
      invitationCodeDoesNotExist: '無效的推薦碼',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere: '如果您透過代理商推薦使用，請輸入推薦碼',
      pleaseEnterTheUsername: '請輸入用戶名',
      pleaseEnterTheCompanyName: '請輸入公司名稱',
      needRegisterAgain: '操作異常，請重新註冊',
      alreadyBind: '您已綁定企業，請勿再次綁定',
    },
  },
  knowledgeFormPage: {
    name: '您的姓名',
    email: '您的信箱',
    companyName: '公司名稱',
    department: '部門',
    role: '職位',
    country: '國家',
    province: '省份',
    pleaseEnter: '請輸入',
    pleaseSelect: '請選擇',
    pleaseEnterTheName: '請輸入您的姓名',
    pleaseEnterTheEmail: '請輸入您的信箱',
    pleaseEnterValidEmail: '請輸入有效的信箱',
    pleaseEnterTheCompanyName: '請輸入您的公司名稱',
    pleaseSelectTheDepartment: '請選擇您的部門',
    pleaseSelectTheRole: '請選擇您的職位',
    pleaseSelectTheCountry: '請選擇您的國家',
    pleaseSelectTheProvince: '請選擇您的省份',
    textIsRequired: '此欄位為必填項',
    submit: '提交',
    download: '下載',
    submitSuccess: '提交成功',
    downloadSuccess: '下載成功',
    title1: '請填寫您的資訊以取得資源',
    title2: '請選擇您想下載的資源',
  },
  dashboard: {
    pdf: {
      downloadReport: '下載報告',
      downloadBtnText: 'PDF下載',
      content: '內容',
      theEnd: '結束',
      thankYouForWatching: '感謝觀看。',
      pdfProcessing: '處理 PDF 中...',
      pdfProcessingDesc:
        'PDF 頁數：{{count}}，數量較多，預計需要 {{seconds}} 秒，點擊保存後，請耐心等待',
      pdfProcessingDesc2: '當前語言版本未進行翻譯，無法生成 PDF',
    },
    ppt: {
      downloadBtnText: 'PPT下載',
      pptProcessingDesc: 'PPT 文件生成中，請耐心等待',
      pptProcessingDesc2: '當前語言版本未進行翻譯，無法生成 PPT',
      pptProcessingDesc3: 'PPT 檔案下載中，請稍候...',
      translateCompleted: 'PPT 翻譯完成',
      exportSuccess: 'PPT 文件導出成功',
      exportFailed: 'PPT 文件導出失敗',
    },
    layout: {
      projectMenuText: '廣告測試項目',
      accountManagementText: '帳戶管理',
      myAccountText: '我的帳戶',
      subscriptionText: '訂閱',
      logout: '退出登入',
      dataDetails: '數據詳情',
      dataAnalysis: '數據分析',
      dataOverview: '數據總覽',
      dataComparison: '數據對比',
    },
    systemMessage: {
      title: '系統消息',
      task: '任務',
      system: '系統',
      noRelevantContent: '找不到相關內容',
      noMore: '沒有更多消息',
    },
    projectPage: {
      createProject: '創建項目',
      searchPlaceholder: '輸入項目/廣告/品牌名稱搜索',
      sortLabel: '廣告效果指數排序',
      sortPlaceholder: '請選擇排序方式',
      sortOption1: '按照效果指數正序',
      sortOption2: '按照效果指數倒序',
      filterSort: '篩選與排序',
      filterBenchmarkTitle: '篩選基準值',
      sortTitle: '排序',
      tabAllCreative: '全部創意（{{count}}）',
      tabGeneralCreative: '常規創意（{{count}}）',
      tabSplashCreative: '開屏創意（{{count}}）',
      generalCreativeLabel: '常規創意',
      splashCreativeLabel: '開屏創意',
      normTypePlaceholder: '請選擇基準值類型',
      totalDesc: '廣告項目（共{{total}}個）',
      noRelevantContent: '找不到相關內容',
      loadMore: '載入更多',
      projectCard: { delete: '刪除', reanalyze: '重新分析', download: '下載' },
      delete: '刪除',
      cancel: '取消',
      message: {
        deleteTitle: '刪除提醒',
        delete: '一旦刪除此項目，所有關聯的數據將變得不可訪問。您確定要繼續刪除嗎？',
        delete1: '本項目為試用項目，刪除後不會返還試用機會',
        delete2: '本項目尚未開始分析，刪除後將為您返還測試次數',
        deleteSuccess: '刪除成功！',
        analysisCountNotEnough: '分析次數不足，請充值後進行嘗試。',
        analysisFailed: '分析失敗，請稍後再試。',
        waitingQuestion: '最多同時分析3個項目。該項目已進入等待隊列，稍後自動開始分析。',
        landscapeQuickCompleted: '您的橫屏-快測項目已完成',
        portraitQuickCompleted: '您的豎屏-快測項目已完成',
        landscapeSurveyCompleted: '您的橫屏-深度洞察項目已完成',
        portraitSurveyCompleted: '您的豎屏-深度洞察項目已完成',
      },
    },
    projectCreatePage: {
      createProject: '創建項目',
      basicInformation: '基本信息',
      projectType: '項目類型',
      projectName: '項目名稱',
      categoryType: '行業',
      brandName: '品牌名稱',
      advertisingInformation: '廣告信息',
      adName: '廣告名稱',
      norm: '基準值',
      targetMarketNorm: '目標市場基準值',
      brandNorm: '品牌基準值',
      taGender: 'TA 性別',
      targetMarket: '目標市場',
      taAge: 'TA 年齡',
      next: '下一步',
      previous: '上一步',
      confirmOrder: '確認訂單',
      estTime: '預估時間',
      minutes: '分鐘',
      consumption: '本次訂單消耗',
      testPoint: '測試次數',
      remaining: '剩餘',
      times: '次',
      type: '類型',
      purchase: '購買',
      outputLanguage: '輸出語言',
      durationCategory: '創意類型',
      durationCategoryDesc: '不同創意類型對應分析指標不同，請選擇最符合當前素材的選項',
      durationCategoryOptions: {
        tenPlus: '常規創意（10秒+）',
        fiveToTen: '開屏創意（5-10秒）',
      },
      adSelection: {
        adCreativeTest: '廣告創意測試',
        adCreativeTestDesc: '測試單廣告創意的受眾反饋，提供分析與建議',
        adCreativeSelection: '廣告創意遴選',
        adCreativeSelectionDesc: '對比多個廣告創意的反饋效果，綜合對比選擇',
        adCreativeEditing: '廣告創意剪輯',
        adCreativeEditingDesc: 'AI智能篩選廣告創意中的精華部分，自動生成廣告創意',
        launchingSoon: '即將上線',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: '食品飲料類',
        packagedFood: '包裝食品',
        confectionery: '糖果/甜食',
        frozenMeals: '速凍食品',
        fastFood: '快餐',
        beverage: '飲料',
        alcohol: '酒精',
        dairy: '乳製品',
        grainAndSeasoning: '糧油調味',
        beverageMixes: '沖飲沖調',
        freshProduce: '生鮮果蔬',
        otherFoodAndBeverage: '其他食品飲料',
        /**----------------------- */
        consumerElectronicsCategory: '消費者電子產品類',
        mobilePhone: '手機',
        computer: '電腦',
        smartDevice: '智能設備',
        phoneAccessories: '手機配件',
        computerAccessories: '電腦配件',
        software: '軟體',
        camera: '照相機',
        officeSupplies: '辦公用品',
        otherConsumerElectronics: '其他電子產品',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: '醫藥保健類',
        otcMedicine: '非處方藥品',
        prescriptionDrugs: '處方藥品',
        healthSupplements: '保健藥品',
        pharmaceuticalCompanies: '製藥公司',
        medicalDevices: '醫療器械',
        medicalServices: '醫療服務',
        pharmacy: '藥店',
        otherPharmaceuticalsAndHealthCare: '其他醫藥保健',
        /**----------------------- */
        beautyAndPersonalCareCategory: '美妝/個護/清潔類',
        hairCare: '洗髮/美髮/護髮',
        womenSkincare: '女士護膚',
        homeCleaning: '家庭清潔',
        bodyCare: '身體護理',
        feminineCare: '女性護理',
        oralCare: '口腔護理',
        menSkincare: '男士護膚',
        makeup: '彩妝',
        fragrances: '香氛',
        beautyServices: '美妝服務',
        otherBeautyAndPersonalCare: '其他美妝/個護/清潔',
        /**----------------------- */
        maternalAndInfantProductsCategory: '母嬰用品類',
        babyFood: '嬰幼兒食品',
        babyCareEssentials: '嬰幼兒用品',
        babyToys: '嬰幼兒玩具',
        otherMaternalAndInfantProducts: '其他母嬰用品',
        /**----------------------- */
        networkAndCommunicationCategory: '網絡及通訊類',
        mobileCarriers: '移動通信運營商',
        internetProviders: '互聯網提供商',
        telecomEquipment: '通信設備',
        otherNetworkAndCommunication: '其他網絡及通訊',
        /**----------------------- */
        travelAndAccommodationCategory: '旅遊住宿類',
        localTourism: '旅遊/區域',
        bookingPlatform: '預訂平台',
        hotels: '旅館',
        airlines: '飛機',
        airport: '機場',
        otherTravelAndAccommodation: '其他旅遊住宿',
        /**----------------------- */
        vehiclesCategory: '交通運輸類',
        motorVehicleProductsAndServices: '機動車產品和服務',
        carBrands: '汽車品牌',
        dealerships: '汽車經銷商',
        carFinance: '汽車金融',
        evCar: '電動汽車',
        motorcycle: '摩托車',
        onlineUsedCarMarketplace: '二手車網上交易平台',
        carRentalPlatform: '汽車租賃平台',
        travelNavigation: '出行導航',
        bicycle: '自行車',
        otherVehicles: '其他交通工具',
        /**----------------------- */
        householdAppliancesCategory: '家用電器類',
        majorAppliances: '大家電',
        healthAndPersonalCareAppliances: '個護健康電器',
        majorKitchenAndBathAppliances: '廚衛大電',
        smallKitchenAppliances: '廚房小電',
        environmentalAppliances: '環境電器',
        cleaningAppliances: '清潔電器',
        otherHouseholdAppliances: '其他家用電器',
        /**----------------------- */
        retailAndServiceCategory: '零售及服務類',
        onlineRetailEcommerce: '在線零售/電商',
        departmentStores: '百貨商店',
        lifeServices: '生活服務業',
        retailServicesAndDelivery: '零售服務/配送',
        supermarkets: '超市',
        otherRetailAndService: '其他零售及服務',
        /**----------------------- */
        apparelCategory: '服裝服飾類',
        footwear: '鞋履',
        clothing: '服裝',
        watchesWatchRetail: '手錶/錶行',
        jewelry: '珠寶首飾',
        bags: '箱包',
        eyewearOpticalStores: '眼鏡/眼鏡店',
        otherClothingAndAccessories: '其他服裝服飾',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: '家裝家居類',
        homeFurnishing: '家居',
        homeImprovement: '家裝',
        otherHomeImprovementAndFurnishings: '其他家裝家居',
        /**----------------------- */
        financialAndInsuranceCategory: '金融/理財/保險類',
        bank: '銀行',
        fintech: '互聯網金融',
        investmentAndFinancialServices: '金融理財',
        insurance: '保險',
        otherFinancialAndInsurance: '其他金融/理財/保險',
        /**----------------------- */
        entertainmentAndLeisureCategory: '休閒娛樂類',
        socialApp: '社交APP',
        toysAndDolls: '玩具玩偶',
        concerts: '演唱會',
        events: '體育賽事',
        movies: '電影',
        themeParks: '主題樂園',
        gambling: '博彩',
        onlineGaming: '網絡遊戲',
        tvChannels: '電視頻道',
        otherEntertainmentAndLeisure: '其他休閒娛樂',
        /**----------------------- */
        industrialAndAgriculturalCategory: '工業農業類',
        industrialSupplies: '工業用品',
        agriculturalSupplies: '農業用品',
        otherIndustrialAndAgricultural: '其他工業農業',
        /**----------------------- */
        petLifeCategory: '寵物生活類',
        petFood: '寵物食品',
        petSupplies: '寵物用品',
        otherPetLife: '其他寵物生活',
        /**----------------------- */
        educationAndLearningCategory: '教育與學習類',
        onlineLearning: '在線教育',
        schools: '學校',
        skillCourses: '技能課程',
        tutoring: '輔導服務',
        universities: '大學',
        otherEducationAndLearning: '其他教育與學習',
        /**----------------------- */
        communityAndPublicServiceCategory: '社區與公共服務類',
        charityCampaigns: '慈善活動',
        ngoAds: '非政府組織廣告',
        otherCommunityAndPublicService: '其他社區與公共服務',
        /**----------------------- */
        otherCategory: '其他類',
        governmentAdvertising: '政府廣告',
        realEstateAdvertising: '房地產廣告',
        otherAdvertising: '其他廣告',
      },
      genderSelect: {
        male: '男性',
        female: '女性',
        all: '全部',
      },
      targetMarketSelect: {
        China: '中國',
        HongKongChina: '中國香港',
        MacauChina: '中國澳門',
        TaiwanChina: '中國台灣',
        Japan: '日本',
        Korea: '韓國',
        Mongolia: '蒙古',
        Singapore: '新加坡',
        Thailand: '泰國',
        Vietnam: '越南',
        Malaysia: '馬來西亞',
        Philippines: '菲律賓',
        Indonesia: '印度尼西亞',
        Cambodia: '柬埔寨',
        Laos: '老撾',
        India: '印度',
        SaudiArabia: '沙烏地阿拉伯',
        Turkey: '土耳其',
        Israel: '以色列',
        UnitedArabEmirates: '阿拉伯聯合酋長國',
        Qatar: '卡塔爾',
        Kuwait: '科威特',
        UnitedKingdom: '英國',
        France: '法國',
        Germany: '德國',
        Netherlands: '荷蘭',
        Belgium: '比利時',
        Austria: '奧地利',
        Italy: '意大利',
        Spain: '西班牙',
        Portugal: '葡萄牙',
        Greece: '希臘',
        Sweden: '瑞典',
        Norway: '挪威',
        Finland: '芬蘭',
        Denmark: '丹麥',
        Estonia: '愛沙尼亞',
        Latvia: '拉脫維亞',
        Russia: '俄羅斯',
        Poland: '波蘭',
        CzechRepublic: '捷克共和國',
        Hungary: '匈牙利',
        Romania: '羅馬尼亞',
        Bulgaria: '保加利亞',
        Slovakia: '斯洛伐克',
        Slovenia: '斯洛文尼亞',
        Ukraine: '烏克蘭',
        UnitedStates: '美國',
        Canada: '加拿大',
        Mexico: '墨西哥',
        Brazil: '巴西',
        LatinAmerica: '拉丁美洲',
        Australia: '澳大利亞',
        NewZealand: '新西蘭',
        Other: '其他',
      },
      languageSelect: {
        english: '英文',
        chinese: '簡體中文',
        japanese: '日文',
        korean: '韓文',
        french: '法文',
        traditionalChinese: '繁體中文',
      },
      placeholder: {
        projectName: '請輸入項目名稱',
        category: '請選擇類別',
        brandName: '請輸入品牌名稱',
        adName: '請輸入廣告名稱',
        norm: '請選擇基準值',
        taGender: '請選擇性別',
        targetMarket: '請選擇目標市場',
        taAge: '請選擇年齡',
        lowerLimit: '下限',
        upperLimit: '上限',
        outputLanguage: '請選擇輸出語言',
      },
      step: {
        step1: '項目信息錄入',
        step2: '訂單信息確認',
      },
      message: {
        success: '創建成功',
        videoDurationOver60s: '影片時長超過{{max}}秒',
        videoDurationLessThan10s: '影片時長小於{{min}}秒',
        videoDurationNeedOver10s: '影片時長需超過 10 秒',
        videoDurationNeedWithin5To10s: '影片時長需處於 5 秒 - 10 秒之間',
        videoDurationNotMatchDurationCategory: '目前影片時長不符合該類型的專案測試要求，請重新上傳影片後重試',
        videoUploadingCannotSwitchDurationCategory: '影片上傳過程中不可切換創意類型，請等待上傳完成',
        videoFormatOrDurationError: '無法讀取影片格式或時長，請檢查影片檔案後重試',
        videoSizeOver200M: '影片大小超過256M',
        videoLandscape: '影片需為橫屏尺寸',
        videoPortrait: '影片需為豎屏尺寸',
        clickToUploadTestVideo: '點擊上傳測試影片',
        uploadFailed: '上傳失敗，請重新上傳',
        uploadDesc1: '支援影片檔案為橫屏尺寸，格式為MP4, MOV',
        uploadDescPortrait: '支援影片檔案為豎屏尺寸，格式為MP4, MOV',
        uploadDesc2: '檔案大小限制為256MB',
        formNotCompleted: '請填寫完整資訊',
        uploadAdVideo: '請上傳廣告影片',
        inputInvalid: '輸入內容無效',
        insufficientTestPoints: '當前測試次數不足，請充值後進行嘗試。',
        reviewProjectInfo: '請仔細檢查您的項目資訊。一旦訂單確認，將無法更改。',
        waitingDesc:
          '最多可同時分析3個項目。超出數量的項目會進入等待佇列，系統將按照順序進行分析。',
        ageRangeInvalid: '年齡範圍僅支援20～55',
        normDesc: '無限版權益，企業定製的自有基準值',
      },
    },
    projectDetailPage: {
      testResults: '測試結果',
      share: '分享',
      shareFailed: '分享失敗',
      shareModal: {
        title: '分享',
        desc: '複製以下文案並分享至社群媒體。',
        saveImage: '保存圖片',
        copyText: '複製文案',
        copySuccess: '複製成功',
        copyFailed: '複製失敗',
        textTemplate:
          '厲害了！我的 AI 影片在 AdEff 測試中擊敗了{{score}}%的同類作品！數據才是硬實力！AdEff AI廣告測評免費進行中，快登入 {{hostname}} 看看你的創作能得多少分？每人享 5 次機會，祝你馬上好評！',
      },
      sharePoster: {
        createdByYou: '您創作的',
        scoreTemplate: '超過了<score>{{score}}</score>的 AIGC 創意',
        statsAt: '統計於',
        certification: '創意認證',
        footerText: '期待您持續創作，帶來更多優質作品!',
      },
      basicInformation: '基本資訊',
      waiting: '等待中',
      ongoing: '正在進行',
      failed: '失敗',
      tryAgain: '重試',
      videoAnalysisFailed: '影片分析失敗',
      message: { projectNotFound: '找不到項目' },
      primaryAnalysis: '關鍵表現',
      detailAnalysis: '時刻解析',
      heatmapAnalysis: '熱力圖',
      analysisStepDesc: 'AI已完成了所有分析任務，詳細分析如下',
      analysisWaitingDesc: '最多同時分析3個項目。該項目已進入等待佇列，稍後自動開始分析',
      aiTip: '報告內容均由 AI 生成，僅供參考',
      subAnalysisDescription: {
        adVideoScore: '廣告效果指數',
        adVideoScoreDesc:
          '廣告效果指數是衡量廣告有效性的綜合指標，能夠預測廣告帶來的短期和長期銷售效果。',
        norm: '基準值',
        normDesc: '行業或歷史數據的基準值，用於橫向對比廣告表現。',
        attentionIndex: '注意指數',
        attentionIndexDesc: '受眾視覺注意力集中情況，反映廣告畫面中情節及元素吸引觀看的能力。',
        emotionIndex: '情緒指數',
        emotionIndexDesc: '受眾正向情緒被激發的程度，反映由廣告引發即時性的情緒波動。',
        cognitionIndex: '認知指數',
        cognitionIndexDesc: '反映受眾認知加工的程度，即在多大程度上對廣告內容進行了思考。',
        theGolden3Seconds: '黃金3秒',
        theGolden3SecondsDesc: '廣告的前3秒是決定廣告成功與否的關鍵時刻。',
        informationTransmission: '信息時刻',
        informationTransmissionDesc: '衡量廣告信息時刻對目標受眾注意力的捕獲能力及興趣激發的效果。',
        brandRelevance: '品牌時刻',
        brandRelevanceDesc: '衡量品牌時刻對目標受眾注意力的捕獲能力及興趣激發的效果。',
        interestStimulation: '興趣時刻',
        interestStimulationDesc: '引發受眾情感共鳴與主動認知的關鍵內容時刻。',
        theEnding3Seconds: '結尾3秒',
        theEnding3SecondsDesc:
          '基於峰終定律，廣告的最後3秒是鞏固觀眾注意力和加強信息傳遞的關鍵時刻。',
      },
      infoDrawer: {
        basicInformation: '基本資訊',
        advertisingInformation: '廣告資訊',
        projectName: '項目名稱',
        brandName: '品牌名稱',
        category: '行業',
        norm: '目標市場基準值',
        normLabel: '基準值',
        brandNorm: '品牌基準值',
        adName: '廣告名稱',
        taGender: 'TA 性別',
        targetMarket: '目標市場',
        taAge: 'TA 年齡',
        ageRange: '{{start}} 到 {{end}} 歲',
        modify: '修改',
        cancel: '取消',
        confirm: '確認',
      },
      videoView: {
        eyeMovementRatio: '注意指數',
        cognitiveEngagement: '認知指數',
        emotionRecognition: '情緒指數',
        subjectiveResponseCurve: '主觀反應曲線',
        realtimeData: '即時數據',
        panoramicData: '全域數據',
        indexAnalysis: '指標分析',
        advantage: '優勢',
        disadvantage: '劣勢',
        suggestions: '建議',
        adVideoScore: '廣告效果指數',
        norm: '基準值',
        analysisStepTitle1: '內容解碼',
        analysisStepTitle2: '回饋預測',
        analysisStepTitle3: '數據整合',
        analysisStepTitle4: '結論推理',
        analysisStepDesc1: '開始進行廣告內容多模態解碼，解碼視覺、解碼音頻、解碼文本、解碼結構...',
        analysisStepDesc2: '開始預測受眾主觀反應，基於廣告的分秒內容，預測受眾眼動和腦電數據...',
        analysisStepDesc3: '開始整合廣告客觀內容和受眾主觀反應數據...',
        analysisStepDesc4: '開始基於推理模型，生成評估結論和行動建議...',
        keyResult: '核心結果',
        videoChart: {
          videoFailed: '影片無法播放',
          videoFailedAction: '請刷新後重試。若多次刷新仍未解決，請聯系我們處理。',
        },
      },
      storyboardView: {
        summary: '總結',
        advantages: '優勢',
        disadvantages: '劣勢',
        suggestions: '建議',
        keyResult: '核心結果',
        norm: '基準值',
        theGolden3Seconds: '黃金3秒',
        informationTransmission: '信息時刻',
        brandRelevance: '品牌時刻',
        interestStimulation: '興趣時刻',
        theEnding3Seconds: '結尾3秒',
      },
      heatmapView: {},
    },
    accountPage: {
      email: '電子郵箱',
      username: '用戶名',
      password: '密碼',
      setPasswordToEnableEmailLogin: '設置密碼以啟用電子郵件登錄',
      uid: 'UID',
      contactAndReceiveNotifications: '聯繫並接收通知',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        '通過此電子郵件接收有關AdEff最新更新的電子郵件。',
      myWorkspace: '我的工作區',
      newRequest: '新請求',
      invitationCode: '推薦碼',
      userName: '用戶名',
      invitationCodeDesc: '每個團隊都有一個獨特的邀請代碼，用於新用戶在註冊期間請求加入團隊',
      table: {
        userName: '用戶名',
        email: '電子郵箱',
        operation: '操作',
        admin: '管理員',
        remove: '移除',
        deny: '拒絕',
        approve: '同意',
      },
      message: {
        yourTeamIsFull: '您的團隊已滿員。您可以聯繫我們以獲得更多會員資格或移除其他成員。',
        invitationLinkSent: '邀請連結已發送到此電子郵件地址！',
        removeReminder: '移除提醒',
        remove: '移除',
        removeMember: '刪除成員後，該成員創建的內容仍將保留。您想繼續刪除成員嗎？',
        removeMemberSuccess: '成員刪除成功！',
        ok: '好的',
        contactUs: '聯繫我們',
        applicationProcessedSuccessfully: '申請處理成功！',
        notificationSettingsTurnedOn: '通知設定已打開',
        notificationSettingsTurnedOff: '通知設定已關閉',
        setPassword: '設定密碼',
        passwordConfirm: '確認',
        passwordCancel: '取消',
        oldPassword: '舊密碼',
        newPassword: '新密碼',
        pleaseEnterTheOldPassword: '請輸入舊密碼',
        pleaseEnterTheNewPassword: '請輸入新密碼',
        incorrectEntryOfOriginalPassword: '原始密碼輸入錯誤',
        passwordUpdatedSuccessfully: '密碼更新成功',
        changeUsername: '修改使用者名稱',
        confirm: '確認',
        cancel: '取消',
        username: '使用者名稱',
        pleaseEnterTheNewUsername: '請輸入新使用者名稱',
        userNameUpdatedSuccessfully: '使用者名稱更新成功',
        addMemberToWorkspace: '新增成員到工作區',
        notAdminOperate: '非管理員，無法進行操作',
        emailAddress: '電子郵件地址',
        send: '發送',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          '我們將向此地址發送一封邀請電子郵件以進行確認。',
        workspaceMemberShip: '工作區會員',
        forMoreMembership: '更多會員資格',
        reachedTheCeiling: '人數已達到上限。',
        incorrectMailboxFormat: '郵箱格式不正確',
        member: '成員',
        changeCorpNameTitle: '修改公司名稱',
        changeCorpNameLabel: '公司名稱',
        pleaseEnterTheCorpName: '請輸入公司名稱',
        changeCorpNameSuccess: '公司名稱修改成功',
        changeCorpNameFailed: '公司名稱修改失敗',
        noPermission: '您沒有權限修改公司名稱',
      },
    },
    subscriptionPage: {
      currentPlan: '目前方案',
      getInvoice: '取得發票',
      remainingTimes: '剩餘次數',
      purchaseMore: '購買更多',
      contactUs: '聯繫我們',
      teamPlan: '專家團隊服務',
      unlimited: '無限版',
      dueDate: '到期日期',
      table: {
        usageRecords: '使用記錄',
        date: '日期',
        projectName: '專案名稱',
        projectType: '專案類型',
        usageCount: '次',
        userName: '使用者名稱',
        noRelevantContent: '找不到相關內容',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: '常規創意項目',
      regularCreative: '常規創意',
      splashCreativeProject: '開屏創意項目',
      splashCreative: '開屏創意',
      projects: '項目數',
      localNorm: '本地基準值',
      projectPassRate: '項目通過率',
      passRate: '通過率',
    },
    dataDetailPage: {
      baseData: '基礎數據',
      totalProjects: '專案總數',
      totalProjectsDesc: '所有參與廣告效果評估的有效專案數量。',
      // averageEffectivenessIndex: '效果指數均值',
      // averageEffectivenessIndexDesc: '所有有效專案的廣告效果指數的平均值。',
      localNormProjects: '本地基準值專案數',
      brandNormProjects: '品牌基準值專案數',
      normProject: '目標市場基準值專案',
      brandNormProject: '品牌基準值專案',
      localNorm: '本地基準值',
      localNormDesc: '以您所在國家為目標市場的有效廣告專案之廣告效果指數平均值。',
      norm: '基準值',
      brandNorm: '品牌基準值',
      brandNormDesc: '以您設定的品牌基準值為目標市場的有效廣告專案之廣告效果指數平均值。',
      localProjectPassRate: '本地專案通過率',
      projectPassRate: '專案通過率',
      brandProjectPassRate: '品牌專案通過率',
      projectPassRateDesc: '廣告效果指數得分高於基準值的專案數量佔所有評估專案總數的比例。',
      advertisingEffectivenessIndexDistribution: '廣告效果指數分佈',
      advertisingEffectivenessIndexDistributionDesc: '展示不同廣告效果指數區間的專案比例。',
      item: '項',
    },
    dataComparisonPage: {
      createCompare: '新增對比',
      createCompareDesc: '支援多選專案進行對比，最多選擇 10 個專案。',
      startCompare: '開始對比',
      compareReport: '對比報告',
      searchPlaceholder: '搜尋對比報告名稱',
      emptyText: '目前暫無對比報告，請先選擇專案進行對比',
      searchEmptyText: '未搜尋到對比報告',
      deleteTitle: '刪除對比報告',
      deleteConfirm: '確認刪除該對比報告？刪除後不可恢復。',
      projectCount: '{{count}} 個專案',
    },
    dataComparisonStartPage: {
      back: '返回', basicInfo: '基本資訊', reportName: '報告名稱:', reportNamePlaceholder: '請輸入對比報告名稱', norm: '基準值:', normPlaceholder: '請選擇基準值', normTip: '請選擇專案對比時使用的基準值', selectProject: '選擇專案', searchPlaceholder: '輸入專案/廣告/品牌名稱搜尋', selectedCountPrefix: ' 已選擇 ', selectedCountSuffix: ' 個專案，最多選擇{{max}}個專案', startCompare: '開始對比', save: '儲存', cancel: '取消', maxSelectedWarning: '最多選擇 10 個專案', reportNameRequired: '請輸入對比報告名稱', normRequired: '請選擇基準值', projectRequired: '請選擇專案',
    },
    dataComparisonInfoPage: {
      defaultReportName: '對比報告名稱', reportNotFound: '報告不存在', back: '返回', modify: '修改', deletedProjectTip: '以下專案：{{names}} 已被刪除，確認後將更新對比報告並移除已刪除專案', confirmDeletedProjects: '確認', metricScore: '指標得分', tabDimension: '五大維度', tabMoment: '關鍵時刻', tabAttitude: '消費者態度', adeffScore: 'AdEff 得分', brandName: '品牌名稱', projectName: '專案名稱', industry: '產業', targetMarket: '目標市場', gender: 'TA性別', age: 'TA年齡', adProject: '廣告專案', normLabel: '基準值', mixedCreativeBenchmarkTip: '當同時對比常規創意和開屏創意時，無基準值', emptyProject: '請選擇專案後查看對比資訊', viewProjectDetail: '查看專案詳情', listSeparator: '、',
      metricLabels: {
        attention: '注意力',
        infectivity: '感染力',
        delivery: '傳達力',
        brand: '品牌力',
        persuasion: '說服力',
        gazeRecognition: '注視識別',
        emotionRecognition: '情緒識別',
        engagementRecognition: '投入識別',
        goldenSeconds: '黃金3秒',
        brandMoment: '品牌時刻',
        productMoment: '興趣時刻',
        messageMoment: '信息時刻',
        endingSeconds: '結尾3秒',
        likeability: '喜好度',
        newInformation: '新信息',
        messageRelevance: '相關度',
        comprehension: '理解度',
        credibility: '可信度',
        brandLinkage: '契合度',
        uniqueness: '獨特性',
        learnMoreIntent: '了解意願',
        purchaseIntent: '購買意願',
        recommendIntent: '分享意願',
        brandLikeabilityLift: '品牌好感提升',
        purchaseIntentionLift: '購買意願提升',
        attentionIndex: '注意指數',
        emotionIndex: '情緒指數',
        cognitionIndex: '認知指數',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: '您的橫屏-深度洞察項目已完成',
        title: {
          text1: '廣告創意測試',
          text2: '測試報告',
        },
        flowAnalysis: {
          desc1: 'AdEff 正在解構影片',
          desc2: '影片解構完畢',
          desc3: '正在分析消費者視覺注意力',
          desc4: '基於消費者畫像，分析關注焦點',
          desc5: '正在生成熱力圖',
          desc6: '動態熱力圖已生成',
          desc7: '正在測量認知神經反應',
          desc8: '正在逐秒分析消費者注視、情緒、投入反應',
          desc9: '認知神經曲線生成中',
          desc10: '認知神經曲線已生成',
          desc11: '分析廣告關鍵時刻表現',
          desc12: '測量黃金3秒、信息時刻、品牌時刻、興趣時刻、結尾3秒的認知神經反應',
          desc13: '關鍵時刻指標合成中',
          desc14: '關鍵時刻分析完成',
          desc15: '消費者態度分析中',
          desc16: '正在分析消費者對品牌、產品與內容的態度傾向',
          desc17: '態度指標合成中',
          desc18: '態度指標分析已完成',
          desc19: '正在生成五大維度指標',
          desc20: '五大維度指標已完成',
          desc21: '全部分析完成，快來看看您的廣告表現吧!',
          terminology: {
            thumbExpand: '展開縮略圖',
            thumbCollapse: '收起縮略圖',
            gazeRecognition: '注視識別',
            gazeRecognitionDesc:
              '消費者視覺注意力集中情況，反映廣告畫面中情節及元素吸引觀看的能力。',
            emotionRecognition: '情緒識別',
            emotionRecognitionDesc: '消費者正向情緒被激發的程度，反映由廣告引發即時性的情緒波動。',
            engagementRecognition: '投入識別',
            engagementRecognitionDesc:
              '消費者投入和沉浸程度，反映在多大程度上對廣告內容進行了思考。',
            theGolden3Seconds: '黃金3秒',
            theGolden3SecondsDesc: '評估廣告最初3秒的內容表現。',
            keyMessage: '信息時刻',
            keyMessageDesc: '衡量廣告信息時刻對目標受眾注意力的捕獲能力及興趣激發的效果。',
            brand: '品牌時刻',
            brandDesc: '衡量品牌時刻對目標受眾注意力的捕獲能力及興趣激發的效果。',
            interest: '興趣時刻',
            interestDesc: '引發受眾情感共鳴與高投入度的關鍵內容的表現。',
            ending3Seconds: '結尾3秒',
            ending3SecondsDesc: '評估廣告結尾3秒的內容表現。',
            score: '得分',
            benchmark: '基準值',
            metrics: '指標',
            attitudePart: {
              attitudeMetrics: '態度指標',
              liking: '喜好度',
              likingDesc: '受眾對廣告的主觀態度，衡量整體喜歡程度。',
              newInformation: '新信息',
              newInformationDesc: '衡量受眾在觀看廣告後，主觀上是否認為從廣告中獲得了此前未知的、關於品牌或產品的有價值的信息。',
              messageRelevance: '相關度',
              messageRelevanceDesc: '衡量受眾主觀上是否認為廣告所傳遞的信息與自身有直接關聯。',
              comprehension: '理解度',
              comprehensionDesc: '衡量廣告所傳遞的核心信息是否被受眾清晰、準確、不費力地理解。',
              credibility: '可信度',
              credibilityDesc: '衡量受眾在多大程度上相信廣告所傳達的信息是真實、可靠、值得信賴的。',
              brandLinkage: '契合度',
              brandLinkageDesc: '衡量受眾能否正確且強烈地將廣告內容與特定品牌關聯起來。',
              uniqueness: '獨特性',
              uniquenessDesc: '衡量廣告是否建立起該品牌相對於競爭對手具有鮮明且有價值的獨特之處的清晰認知。',
              willing: '了解意願',
              willingDesc: '衡量受眾在觀看廣告後，主動採取行動去進一步了解和探索品牌或產品相關信息的主觀可能性。',
              purchase: '購買意願',
              purchaseDesc: '衡量受眾在觀看廣告後，在未來某個時期考慮選擇或購買該品牌產品的主觀可能性。',
              share: '分享意願',
              shareDesc: '衡量受眾在觀看廣告後，主動將廣告或品牌信息分享給他人的主觀可能性。',
              brandLikeLift: '品牌好感提升',
              brandLikeLiftDesc: '衡量廣告播放後，受眾對品牌或產品的喜好程度發生了何種方向及何種程度的變化。',
              purchaseIntentLift: '購買意願提升',
              purchaseIntentLiftDesc: '衡量廣告播放後，受眾考慮購買該品牌產品的意願發生了何種方向及何種程度的變化。',
            },
            dimensionPart: {
              forceDrives: '維度指標',
              attension: '注意力',
              emotionalImpact: '感染力',
              messageClarity: '傳達力',
              brandPower: '品牌力',
              persuasion: '說服力',
              attentionForce: '注意力',
              attentionForceDesc: '衡量創意吸引並維持消費者視覺與聽覺注意的能力。',
              emotionalForce: '感染力',
              emotionalForceDesc: '衡量創意激發觀眾本能、即時的情感共鳴與情緒波動的強度。',
              messageForce: '傳達力',
              messageForceDesc: '衡量創意的核心信息被目標觀眾清晰識別、準確理解和深刻記憶的有效性。',
              brandForce: '品牌力',
              brandForceDesc: '衡量創意強化品牌身份、提升品牌好感並建立深刻品牌關聯的效能。',
              persuasiveForce: '說服力',
              persuasiveForceDesc: '衡量創意改變用戶認知、驅動行為意向的最終轉化能力。',
            },
            result: {
              results: '結果',
              pass: '通過',
              notPass: '不通過',
              adeffScore: 'AdEff得分',
              adeffScoreDesc: 'AdEff得分旨在衡量廣告的整體有效性。',
              benchmarkDesc: '廣告所在國家/地區所有上傳廣告的AdEff得分均值，用於對比廣告在該國家/地區的表現。',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: '等待中...',
            description: '正在為您生成測試報告...',
          },
          generating: '持續生成中...',
          freeTrialLockText1: '試用狀態無法預覽或下載完整報告，',
          freeTrialLockText2: '充值後即可解鎖。',
        },
      },
    },
  },
  professor: {
    account: '帳號',
    password: '密碼',
    login: '登錄',
    expertReviews: '專家評測',
    adVideoScore: '廣告效果指數',
    subjectiveResponseCurve: '主觀反應曲線',
    indexAnalysis: '指標分析',
    keyResult: '核心結果',
    theGolden3Seconds: '黃金3秒',
    informationTransmission: '信息時刻',
    brandRelevance: '品牌時刻',
    interestStimulation: '興趣時刻',
    theEnding3Seconds: '結尾3秒',
    heatMap: '熱力圖',
    suggestion: '反饋建議',
    suggestion1: '建議',
    submit: '提交',
    next: '下一題',
    summary: '總結',
    advantages: '優勢',
    disadvantages: '劣勢',
    option1: '符合預期',
    option2: '不符合預期',
    resultJudgment: '結果判斷',
    placeholder: '請輸入建議',
    waitRateCount: '待評測廣告數量',
    unfinishedTitle: '提醒',
    unfinishedRate: '當前項目還有未評測內容，是否確認退出？',
    unfinishedConfirm: '繼續評測',
    unfinishedCancel: '退出',
    message: {
      submitSuccess: '感謝您的評價',
      submitSuccess1: '您已完成該項目的評測，感謝您的評價',
      loginSuccess: '登錄成功',
      rateUnfinished: '您還未評測當前內容，請填寫後再進入下一題',
      rateLocation: '已為您自動定位到未評測內容',
    },
  },
  modals: {
    freeTrialModal: {
      title: '申請試用',
      title1: '免費試用',
      trial: '試用',
      hiddenBoxText1: '檢測到多項優勢、劣勢、建議',
      hiddenBoxText2: '訂閱後可獲取完整報告',
      hiddenBoxBtn: '立即訂閱',
      applyBox: {
        name: '您的姓名',
        tel: '聯繫電話',
        department: '部門',
        role: '職位',
        country: '國家',
        city: '城市',
        pleaseEnter: '請輸入',
        pleaseSelect: '請選擇',
        pleaseEnterTheName: '請輸入您的姓名',
        pleaseEnterTheTel: '請輸入您的聯繫方式',
        pleaseEnterValidTel: '請輸入有效的聯繫方式',
        pleaseEnterValidEmail: '請輸入有效的郵箱',
        pleaseSelectTheDepartment: '請選擇您的部門',
        pleaseSelectTheRole: '請選擇您的職位',
        pleaseSelectTheCountry: '請選擇您的國家',
        pleaseEnterTheCity: '請輸入您的城市',
        textIsRequired: '此字段為必填項',
        submit: '提交',
        tip: '每家企業僅有一次免費試用機會',
      },
      gotTrial: '您已獲得試用機會！',
      goPc: '請前往PC網頁端創建項目。',
      back: '返回',
      country: {
        China: '中國',
        Japan: '日本',
        Korea: '韓國',
        Indonesia: '印度尼西亞',
        Thailand: '泰國',
        Singapore: '新加坡',
        Malaysia: '馬來西亞',
        Vietnam: '越南',
        Germany: '德國',
        Britain: '英國',
        France: '法國',
        Italy: '意大利',
        Russia: '俄羅斯',
        Spain: '西班牙',
        Turkey: '土耳其',
        America: '美國',
        Canada: '加拿大',
        Brazil: '巴西',
        Other: '其它',
      },
      department: {
        Brand: '品牌部',
        Market: '市場研究及洞察部',
        Marketing: '營銷部',
        IT: 'IT或數字化部',
        Procurement: '採購部',
        Other: '其它',
      },
      role: {
        President: '總裁/副總裁/總經理',
        CMO: 'CMO或其他C-level管理層',
        Director: '部門總監',
        Manager: '部門經理',
        Other: '其它',
      },
      message: {
        submitSuccess: '提交成功',
        submitFailed: '提交失敗，請稍後再試',
      },
    },
    downloadPptRechargeModal: {
      title: '無法下載',
      desc1: '試用狀態下無法下載',
      desc2: '訂閱後可下載完整報告',
      btn: '立即訂閱',
    },
    checkInvitationCodeModal: {
      invitationCode: '推薦碼',
      invitationCodeDesc1: '推薦碼信息不可修改，如需修改，請聯繫我們',
      invitationCodeDesc2: '如果您透過代理商推薦使用，請輸入推薦碼',
      invitationCodePlaceholder: '請輸入推薦碼',
      invitationCodeError: '推薦碼有誤',
      invitationCodeSuccess: '推薦碼綁定成功',
      ok: '確定',
      cancel: '取消',
    },
    aigcPromotionModal: {
      title: 'AIGC 創作者福利',
      subTitle: '註冊即可獲得 <tmp>5</tmp> 次AI影片測評機會',
      desc1: '參與 AIGC 創意測試專項活動，用 AdEff 為你的 AIGC 創意進行全方位測評！',
      desc2: '點擊下方完成註冊，即刻免費領取 5 次 AIGC 創意測試機會。',
      registerBtn: '註冊獲取測試機會',
      tip: '僅限通過 AIGC 創作者活動入口註冊的新用戶',
      floatTitle: '免費測試',
    },
  },
}

export default TRANSLATION
